import Model from "./base/model";

class nfServiceFile extends Model{
  resourceName() {
    return "nf_service_files";
  }

  fields() {
    return {
      nf_service_path: "",
      nf_service_name: "",
      number: "",
      value: "",
      iss: "",
      description: "",
      created_at: "",
      related_order_additional_services: "",
      cte_files: "",
    }
  }
}

export default new nfServiceFile();
